import { render, staticRenderFns } from "./PageProductDetail.vue?vue&type=template&id=58e393a4&"
import script from "./PageProductDetail.js?vue&type=script&lang=js&"
export * from "./PageProductDetail.js?vue&type=script&lang=js&"
import style0 from "./PageProductDetail.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PageProductDetail.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Frent%2Fcomponents%2Fproduct%2FPageProductDetail%2FPageProductDetail.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports